/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createConcatTransform } from '../../factoriesAny.js';
export var concatTransformDependencies = {
  isIntegerDependencies: isIntegerDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createConcatTransform: createConcatTransform
};